import {
  ClickedLocation,
  useClickedSupplierAccordionAnalytics,
} from '@bridebook/web/app-basic/lib/analytics/hooks/use-clicked-supplier-accordion-analytics';
import {
  getSupplierAchievements,
  getSupplierBadges,
  getSupplierCountry,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { memo } from 'react';
import AwardsComp from '@bridebook/web/app-basic/components/supplier/sections/awards/awards';

const Awards = () => {
  const achievements = useSelector(getSupplierAchievements);
  const badges = useSelector(getSupplierBadges);
  const supplierCountry = useSelector(getSupplierCountry);
  const clickedAccordionAnalytics = useClickedSupplierAccordionAnalytics(ClickedLocation.Awards);

  return (
    <AwardsComp
      onToggleAccordion={clickedAccordionAnalytics}
      badges={badges}
      achievements={achievements}
      supplierCountry={supplierCountry}
    />
  );
};

export default memo(Awards);
